import {
  SEGMENT_FIELD_TYPES,
  SEGMENT_TYPES,
  URL_MAX_LENGTH,
  IMAGE_POSITION_OPTIONS,
  STYLE_OPTIONS,
  field,
  visualStyleProperty,
  commonSegment
} from "./segmentRegistryCore";

const closingSegments = {
  [SEGMENT_TYPES.FOOTER]: commonSegment({
    id: SEGMENT_TYPES.FOOTER,
    visibilityPath: "sections.showFooter",
    elementEditingReady: true,
    elementTargets: {
      "@footer.logo": {
        kind: "image",
        label: "Logo",
        fieldPath: "theme.logoUrl",
        mobileVariantPath: "theme.compactLogoUrl",
        showPath: "footer.showLogo",
        chips: ["Marca"],
        logoAppearance: {
          groups: [
            {
              label: "Pie de página",
              colorPath: "footer.logoColor",
              sizePath: "footer.logoMaxHeight",
              assetPaths: ["theme.logoUrl", "theme.compactLogoUrl"],
              min: 20,
              max: 160,
              step: 1,
            },
          ],
        },
      },
      "@footer.brand": {
        kind: "footer-group",
        editorMode: "brand",
        label: "Marca",
        fieldPaths: ["business.name", "footer.tagline"],
      },
      "@footer.navigation": {
        kind: "footer-group",
        editorMode: "navigation",
        label: "Navegación",
        fieldPaths: [
          "footer.navigationTitle",
          "footer.homeLabel",
          "footer.productsLabel",
          "navigation.aboutLabel",
          "navigation.highlightsLabel",
          "footer.contactLabel",
        ],
      },
      "@footer.contact": {
        kind: "contact-group",
        editorMode: "footer-contact",
        label: "Contacto",
        fieldPaths: [
          "footer.contactTitle",
          "business.phone",
          "business.email",
          "business.address",
          "business.city",
          "business.province",
          "business.country",
          "business.schedule",
        ],
      },
      "@footer.socials": {
        kind: "footer-group",
        editorMode: "socials",
        label: "Redes sociales",
        fieldPaths: [
          "navigation.showSocialLinks",
          "navigation.socialTitle",
          "business.whatsapp",
          "business.socials.instagram",
          "business.socials.facebook",
          "business.socials.youtube",
          "business.socials.linkedin",
          "business.socials.tiktok",
          "business.socials.website",
        ],
      },
    },
    shellPropertyPaths: ["footer.style"],
    // Footer hereda la paleta global. No exponemos una segunda paleta local
    // como si los theme.* fueran colores exclusivos del pie de página.
    shellVisualPalette: false,
    properties: [
      field("sections.showFooter", SEGMENT_FIELD_TYPES.BOOLEAN, {
        label: "Mostrar pie de página",
      }),
      field("footer.style", SEGMENT_FIELD_TYPES.SELECT, {
        label: "Estilo del pie de página",
        options: STYLE_OPTIONS,
      }),
      field("footer.showLogo", SEGMENT_FIELD_TYPES.BOOLEAN, {
        label: "Mostrar logo",
      }),
      field("footer.logoPosition", SEGMENT_FIELD_TYPES.SELECT, {
        label: "Posición del logo",
        options: IMAGE_POSITION_OPTIONS,
      }),
      field("footer.logoColor", SEGMENT_FIELD_TYPES.COLOR, {
        label: "Logo · color SVG",
        editable: false,
      }),
      field("footer.logoMaxHeight", SEGMENT_FIELD_TYPES.NUMBER, {
        label: "Logo · alto máximo (px)",
        limits: { min: 20, max: 160, step: 1 },
        editable: false,
      }),
      field("footer.tagline", SEGMENT_FIELD_TYPES.TEXTAREA, {
        label: "Descripción corta",
        maxLength: 700,
      }),
      field("footer.copyright", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Derechos de autor",
        maxLength: 220,
      }),
      field("footer.navigationTitle", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Título de navegación",
        maxLength: 120,
      }),
      field("footer.contactTitle", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Título de contacto",
        maxLength: 120,
      }),
      field("footer.homeLabel", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Inicio",
        maxLength: 80,
      }),
      field("footer.productsLabel", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Productos o servicios",
        maxLength: 80,
      }),
      field("footer.contactLabel", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Contacto",
        maxLength: 80,
      }),
      field("navigation.aboutLabel", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Sobre nosotros",
        maxLength: 100,
        shared: true,
      }),
      field("navigation.highlightsLabel", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Diferenciales",
        maxLength: 100,
        shared: true,
      }),
      field("navigation.showSocialLinks", SEGMENT_FIELD_TYPES.BOOLEAN, {
        label: "Mostrar redes sociales",
        shared: true,
      }),
      field("navigation.socialTitle", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Título de redes",
        maxLength: 120,
        shared: true,
      }),
      field("business.name", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Nombre del negocio",
        maxLength: 140,
        shared: true,
      }),
      field("business.shortDescription", SEGMENT_FIELD_TYPES.TEXTAREA, {
        label: "Descripción breve del negocio",
        maxLength: 700,
        shared: true,
      }),
      field("business.whatsapp", SEGMENT_FIELD_TYPES.TEXT, {
        label: "WhatsApp",
        maxLength: 40,
        shared: true,
      }),
      field("business.phone", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Teléfono",
        maxLength: 80,
        shared: true,
      }),
      field("business.email", SEGMENT_FIELD_TYPES.EMAIL, {
        label: "Email",
        maxLength: 180,
        shared: true,
      }),
      field("business.address", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Dirección",
        maxLength: 260,
        shared: true,
      }),
      field("business.city", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Ciudad",
        maxLength: 120,
        shared: true,
      }),
      field("business.province", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Provincia",
        maxLength: 120,
        shared: true,
      }),
      field("business.country", SEGMENT_FIELD_TYPES.TEXT, {
        label: "País",
        maxLength: 120,
        shared: true,
      }),
      field("business.schedule", SEGMENT_FIELD_TYPES.TEXTAREA, {
        label: "Horarios",
        maxLength: 400,
        shared: true,
      }),
      field("business.socials.instagram", SEGMENT_FIELD_TYPES.URL, {
        label: "Instagram",
        maxLength: URL_MAX_LENGTH,
        shared: true,
      }),
      field("business.socials.facebook", SEGMENT_FIELD_TYPES.URL, {
        label: "Facebook",
        maxLength: URL_MAX_LENGTH,
        shared: true,
      }),
      field("business.socials.youtube", SEGMENT_FIELD_TYPES.URL, {
        label: "YouTube",
        maxLength: URL_MAX_LENGTH,
        shared: true,
      }),
      field("business.socials.linkedin", SEGMENT_FIELD_TYPES.URL, {
        label: "LinkedIn",
        maxLength: URL_MAX_LENGTH,
        shared: true,
      }),
      field("business.socials.tiktok", SEGMENT_FIELD_TYPES.URL, {
        label: "TikTok",
        maxLength: URL_MAX_LENGTH,
        shared: true,
      }),
      field("business.socials.website", SEGMENT_FIELD_TYPES.URL, {
        label: "Sitio web",
        maxLength: URL_MAX_LENGTH,
        shared: true,
      }),
      field("theme.logoUrl", SEGMENT_FIELD_TYPES.IMAGE, {
        label: "Logo principal",
        maxLength: URL_MAX_LENGTH,
        shared: true,
        positionPath: "footer.logoPosition",
      }),
      field("theme.compactLogoUrl", SEGMENT_FIELD_TYPES.IMAGE, {
        label: "Logo compacto",
        maxLength: URL_MAX_LENGTH,
        shared: true,
      }),
      visualStyleProperty(SEGMENT_TYPES.FOOTER),
    ],
  }),
  [SEGMENT_TYPES.FLOATING_WHATSAPP]: commonSegment({
    id: SEGMENT_TYPES.FLOATING_WHATSAPP,
    visibilityPath: "sections.showFloatingWhatsapp",
    elementEditingReady: true,
    defaultElementId: "floatingWhatsapp.button",
    elementTargets: {
      "@floatingWhatsapp.button": {
        kind: "floating-whatsapp",
        label: "WhatsApp flotante",
        fieldPaths: [
          "sections.showFloatingWhatsapp",
          "business.whatsapp",
          "contact.whatsappMessage",
          "contact.floatingWhatsappAriaLabel",
          "widgets.floatingWhatsapp.style.backgroundColor",
          "widgets.floatingWhatsapp.style.iconColor",
          "widgets.floatingWhatsapp.style.borderColor",
          "widgets.floatingWhatsapp.style.borderWidth",
          "widgets.floatingWhatsapp.style.borderRadius",
          "widgets.floatingWhatsapp.style.boxShadow",
          "widgets.floatingWhatsapp.style.size",
          "widgets.floatingWhatsapp.style.hover.backgroundColor",
          "widgets.floatingWhatsapp.style.hover.iconColor",
          "widgets.floatingWhatsapp.style.hover.borderColor",
          "widgets.floatingWhatsapp.style.hover.boxShadow",
        ],
      },
    },
    shellVisualBackground: false,
    shellVisualPalette: false,
    properties: [
      field("sections.showFloatingWhatsapp", SEGMENT_FIELD_TYPES.BOOLEAN, {
        label: "Mostrar WhatsApp flotante",
      }),
      field("business.whatsapp", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Número de WhatsApp",
        maxLength: 40,
        shared: true,
      }),
      field("contact.whatsappMessage", SEGMENT_FIELD_TYPES.TEXTAREA, {
        label: "Mensaje inicial",
        maxLength: 500,
        shared: true,
      }),
      field("contact.floatingWhatsappAriaLabel", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Descripción accesible del botón",
        maxLength: 160,
      }),
      field("widgets.floatingWhatsapp.style.backgroundColor", SEGMENT_FIELD_TYPES.COLOR, {
        label: "Fondo",
        maxLength: 100,
        explicitVisual: true,
        defaultValue: "#25D366",
      }),
      field("widgets.floatingWhatsapp.style.iconColor", SEGMENT_FIELD_TYPES.COLOR, {
        label: "Ícono",
        maxLength: 100,
        explicitVisual: true,
        defaultValue: "#FFFFFF",
      }),
      field("widgets.floatingWhatsapp.style.borderColor", SEGMENT_FIELD_TYPES.COLOR, {
        label: "Borde",
        maxLength: 100,
        explicitVisual: true,
        defaultValue: "transparent",
      }),
      field("widgets.floatingWhatsapp.style.borderWidth", SEGMENT_FIELD_TYPES.NUMBER, {
        label: "Ancho de borde (px)",
        explicitVisual: true,
        defaultValue: 0,
        limits: { min: 0, max: 16, step: 1 },
      }),
      field("widgets.floatingWhatsapp.style.borderRadius", SEGMENT_FIELD_TYPES.NUMBER, {
        label: "Redondeado (px)",
        explicitVisual: true,
        defaultValue: 999,
        limits: { min: 0, max: 999, step: 1 },
      }),
      field("widgets.floatingWhatsapp.style.boxShadow", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Sombra",
        maxLength: 300,
        explicitVisual: true,
        defaultValue: "0 8px 28px rgba(0,0,0,.3)",
      }),
      field("widgets.floatingWhatsapp.style.size", SEGMENT_FIELD_TYPES.NUMBER, {
        label: "Tamaño (px)",
        explicitVisual: true,
        defaultValue: 56,
        limits: { min: 40, max: 96, step: 1 },
      }),
      field("widgets.floatingWhatsapp.style.hover.backgroundColor", SEGMENT_FIELD_TYPES.COLOR, {
        label: "Fondo hover",
        maxLength: 100,
        explicitVisual: true,
        defaultValue: "#1EBE5D",
      }),
      field("widgets.floatingWhatsapp.style.hover.iconColor", SEGMENT_FIELD_TYPES.COLOR, {
        label: "Ícono hover",
        maxLength: 100,
        explicitVisual: true,
        defaultValue: "#FFFFFF",
      }),
      field("widgets.floatingWhatsapp.style.hover.borderColor", SEGMENT_FIELD_TYPES.COLOR, {
        label: "Borde hover",
        maxLength: 100,
        explicitVisual: true,
        defaultValue: "transparent",
      }),
      field("widgets.floatingWhatsapp.style.hover.boxShadow", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Sombra hover",
        maxLength: 300,
        explicitVisual: true,
        defaultValue: "0 8px 28px rgba(0,0,0,.3)",
      }),
    ],
  }),
};

export default closingSegments;
